import { useState, useEffect } from "react";
import { googleMapService } from "../../services";
import { GoogleMapConstants } from "../../constants";

const useFetchCoordinatesByCity = (
  cityFilter,
  cities,
  dataSource, 
  pageData
) => {
  const [location, setLocation] = useState(null);
  const [mapCenter, setMapCenter] = useState({
    lat: GoogleMapConstants.DEFAULT_LATITUDE,
    lng: GoogleMapConstants.DEFAULT_LONGITUDE,
  });

  useEffect(() => {
    const fetchCoordinates = async () => {
      const selectedCity = cities.find((city) => city.id == cityFilter)?.name;
      try {
        const res = await googleMapService.getLocationPointsByCity(
            selectedCity
          );
          const data = res.data;
        if (dataSource?.length === 0) {

        
          if (data?.results?.length > 0) {
            const { lat, lng } = data.results[0]?.geometry?.location;
            setLocation({
              latitude: parseFloat(lat),
              longitude: parseFloat(lng),
            });
            setMapCenter({
              lat: parseFloat(lat),
              lng: parseFloat(lng),
            });
          }
        } else {
          setLocation(null);
        }
      } catch (error) {
        setLocation(null);
      }
    };

    fetchCoordinates();
  }, [cityFilter, cities , pageData , dataSource]);

  return { location, mapCenter };
};

export default useFetchCoordinatesByCity;
